var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__user animate__animated animate__fadeInUp animate__fastest",class:{'underline': _vm.needUnderlined},attrs:{"id":"conversation-user-message"}},[_vm._v("\n  "+_vm._s(_vm.message.content)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }